<template>
	<app-content class="h-panel">
		<div class="h-panel-bar">
			<span class="h-panel-title">总账</span>
		</div>
		<div class="margin-right-left margin-top no-print">
			<account-date-choose v-model="accountDate"/>
			<span class="range-sep">至</span>
			<DatePicker type="month" v-model="endMonth" format="YYYY-MM" placeholder="结束月份(可选)" :clearable="true" style="width: 130px; vertical-align: middle;"></DatePicker>
			<div class="float-right">
				<Checkbox v-model="showNumPrice">显示数量金额</Checkbox>
				<Button icon="fa fa-download" @click="doExport">导出</Button>
				<Button icon="fa fa-print" @click="doPrint">打印</Button>
			</div>
		</div>
		<div class="h-panel-body margin" :space-x="10" style="overflow-x: auto;padding: 0;">
			<Loading text="总账数据加载中..." :loading="loading"></Loading>
			<div class="print-header">
				<div class="print-title">总账</div>
				<div class="print-sub">
					<span>编制单位：{{currentAccountSets?currentAccountSets.companyName:''}}</span>
					<span>期间：{{printPeriod}}</span>
					<span>单位：元</span>
				</div>
			</div>
			<table class="summary" v-if="!showNumPrice">
				<tr class="header bg-primary-color white-color">
					<td>科目编码</td>
					<td>科目名称</td>
					<td>期间</td>
					<td>摘要</td>
					<td>借方金额</td>
					<td>贷方金额</td>
					<td>方向</td>
					<td>余额</td>
				</tr>
				<template v-for="group in groupedList">
					<tr class="type-header">
						<td colspan="8"><b>{{group.type}}</b></td>
					</tr>
					<template v-for="item in group.items">
						<tr class="bg-gray3-color">
							<td colspan="8">
								<span @click="toggleSummary(item)" class="text-hover">
									<i class="fa fa-caret-down" :class="{'fa-caret-right':item._expand}"></i>
									<span class="primary-color font-bold"> {{item.subject.name}}</span>
								</span>
								<span class="text-hover primary-color" style="margin-left: 12px; font-size: 12px;" @click.stop="goDetail(item.subject)">查明细</span>
							</td>
						</tr>
						<tr v-if="!item._expand" class="summary" v-for="s in item.summary">
							<td>{{item.subject.code}}</td>
							<td>{{item.subject.name}}</td>
							<td>{{s.voucherDate|fqFormat}}</td>
							<td>{{s.summary}}</td>
							<td align="right">{{s.debitAmount}}</td>
							<td align="right">{{s.creditAmount}}</td>
							<td align="center" :class="{'abnormal-balance':isAbnormalBalance(item.subject, s)}">{{s.balanceDirection}}</td>
							<td align="right" :class="{'abnormal-balance':isAbnormalBalance(item.subject, s)}">{{s.balance}}</td>
						</tr>
					</template>
				</template>
				<tr v-if="!datalist.length">
					<td colspan="8" class="text-center padding">暂无数据</td>
				</tr>
			</table>
			<table v-else class="cus-table" style="width: 1780px;">
				<thead class="header">
				<tr>
					<td rowspan="2" width="100">科目编码</td>
					<td rowspan="2" width="100">科目名称</td>
					<td rowspan="2" width="80">单位</td>
					<td colspan="4">期初余额</td>
					<td colspan="2">本期借方</td>
					<td colspan="2">本期贷方</td>
					<td colspan="2">本年累计借方</td>
					<td colspan="2">本年累计贷方</td>
					<td colspan="4">期末余额</td>
				</tr>
				<tr>
					<td width="100">方向</td>
					<td width="100">数量</td>
					<td width="100">单价</td>
					<td width="100">金额</td>
					<td width="100">数量</td>
					<td width="100">金额</td>
					<td width="100">数量</td>
					<td width="100">金额</td>
					<td width="100">数量</td>
					<td width="100">金额</td>
					<td width="100">数量</td>
					<td width="100">金额</td>
					<td width="100">方向</td>
					<td width="100">数量</td>
					<td width="100">单价</td>
					<td width="100">金额</td>
				</tr>
				</thead>
				<template v-for="group in groupedList">
					<tr class="type-header">
						<td colspan="20"><b>{{group.type}}</b></td>
					</tr>
					<tr v-for="{subject,summary} in group.items" :key="subject.id">
					<td>{{subject.code}}</td>
					<td>{{subject.name}}</td>
					<td class="text-center">{{subject.unit}}</td>
					<td class="text-center" :class="{'abnormal-balance':isAbnormalBalance(subject, summary[0])}">{{summary[0].balanceDirection}}</td>
					<td class="text-right">{{summary[0].num}}</td>
					<td class="text-right">{{summary[0].price|numFormat}}</td>
					<td class="text-right" :class="{'abnormal-balance':isAbnormalBalance(subject, summary[0])}">{{summary[0].balance|numFormat}}</td>
					<td class="text-right">{{summary[1].debitNum}}</td>
					<td class="text-right">{{summary[1].debitAmount|numFormat}}</td>
					<td class="text-right">{{summary[1].creditNum}}</td>
					<td class="text-right">{{summary[1].creditAmount|numFormat}}</td>
					<td class="text-right">{{summary[2].debitNum}}</td>
					<td class="text-right">{{summary[2].debitAmount|numFormat}}</td>
					<td class="text-right">{{summary[2].creditNum}}</td>
					<td class="text-right">{{summary[2].creditAmount|numFormat}}</td>
					<td class="text-center" :class="{'abnormal-balance':isAbnormalBalance(subject, summary[1])}">{{summary[1].balanceDirection}}</td>
					<td class="text-right">{{summary[1].numBalance}}</td>
					<td class="text-right">{{summary[1].price|numFormat}}</td>
					<td class="text-right" :class="{'abnormal-balance':isAbnormalBalance(subject, summary[1])}">{{summary[1].balance|numFormat}}</td>
				</tr>
				</template>
			</table>
		</div>
	</app-content>
</template>

<script>
	import moment from 'moment';
	import {mapState} from 'vuex';
	import {exportCsv} from '../../js/common/export-file';

	//科目类别展示顺序：财务五类在前，预算三类在后，未识别类别排最后
	const TYPE_ORDER = ['资产', '负债', '净资产', '收入', '费用', '预算收入', '预算支出', '预算结余'];

	export default {
		name: 'GeneralLedger',
		data() {
			return {
				loading: false,
				accountDate: null,
				endMonth: null,
				showNumPrice: false,
				numPriceDisabled: true,
				datalist: []
			};
		},
		computed: {
			...mapState(['currentAccountSets']),
			printPeriod() {
				if (!this.accountDate) {
					return '';
				}
				let s = moment(this.accountDate).format('YYYY年MM月');
				if (this.endMonth && moment(this.endMonth, 'YYYY-MM').isAfter(moment(this.accountDate), 'month')) {
					s += ' 至 ' + moment(this.endMonth, 'YYYY-MM').format('YYYY年MM月');
				}
				return s;
			},
			groupedList() {
				let groups = [];
				let map = {};
				this.datalist.forEach(item => {
					let t = item.subject && item.subject.type ? String(item.subject.type) : '其他';
					if (!map[t]) {
						map[t] = {type: t, items: []};
						groups.push(map[t]);
					}
					map[t].items.push(item);
				});
				groups.sort((a, b) => {
					let ia = TYPE_ORDER.indexOf(a.type);
					let ib = TYPE_ORDER.indexOf(b.type);
					return (ia < 0 ? 99 : ia) - (ib < 0 ? 99 : ib);
				});
				return groups;
			}
		},
		watch: {
			accountDate() {
				this.loadList();
			},
			endMonth() {
				this.loadList();
			},
			showNumPrice() {
				this.loadList();
			}
		},
		methods: {
			loadList() {
				this.loading = true;
				let params = {
					accountDate: this.accountDate,
					showNumPrice: this.showNumPrice
				};
				if (this.endMonth && moment(this.endMonth, 'YYYY-MM').isAfter(moment(this.accountDate), 'month')) {
					params.endAccountDate = moment(this.endMonth, 'YYYY-MM').endOf('month').format('YYYY-MM-DD');
				}
				this.$api.accountbook.loadGeneralLedger(params).then(({data}) => {
					this.datalist = data;
					this.loading = false;
				});
			},
			toggleSummary(item) {
				this.$set(item, '_expand', !item._expand);
			},
			//余额方向与科目默认方向相反且余额非零时视为异常（如资产类科目挂出贷方余额），红字提示
			isAbnormalBalance(subject, row) {
				return !!(subject && subject.balanceDirection
					&& row.balanceDirection && row.balanceDirection !== '平'
					&& row.balanceDirection !== subject.balanceDirection
					&& Number(row.balance) !== 0);
			},
			//联查：跳转明细账并定位到该科目，携带当前期间
			goDetail(subject) {
				if (!subject || !subject.code) {
					return;
				}
				let query = {
					subjectCode: subject.code,
					accountDate: moment(this.accountDate).format('YYYY-MM-DD')
				};
				if (this.endMonth) {
					query.endMonth = this.endMonth;
				}
				this.$router.push({name: 'DetailedAccounts', query});
			},
			doExport() {
				if (!this.datalist.length) {
					this.$Message.error('暂无数据可导出');
					return;
				}
				let headers, rows = [];
				if (!this.showNumPrice) {
					headers = ['类别', '科目编码', '科目名称', '期间', '摘要', '借方金额', '贷方金额', '方向', '余额'];
					this.datalist.forEach(({subject, summary}) => {
						(summary || []).forEach(s => {
							rows.push([
								subject.type || '', subject.code, subject.name,
								s.voucherDate ? moment(s.voucherDate).format('YYYY-MM-DD') : '',
								s.summary, s.debitAmount, s.creditAmount, s.balanceDirection, s.balance
							]);
						});
					});
				} else {
					headers = ['类别', '科目编码', '科目名称', '单位',
						'期初方向', '期初数量', '期初单价', '期初金额',
						'本期借方数量', '本期借方金额', '本期贷方数量', '本期贷方金额',
						'本年累计借方数量', '本年累计借方金额', '本年累计贷方数量', '本年累计贷方金额',
						'期末方向', '期末数量', '期末单价', '期末金额'];
					this.datalist.forEach(({subject, summary}) => {
						if (!summary || summary.length < 3) return;
						rows.push([
							subject.type || '', subject.code, subject.name, subject.unit,
							summary[0].balanceDirection, summary[0].num, summary[0].price, summary[0].balance,
							summary[1].debitNum, summary[1].debitAmount,
							summary[1].creditNum, summary[1].creditAmount,
							summary[2].debitNum, summary[2].debitAmount,
							summary[2].creditNum, summary[2].creditAmount,
							summary[1].balanceDirection, summary[1].numBalance, summary[1].price, summary[1].balance
						]);
					});
				}
				exportCsv('总账-' + (this.accountDate ? moment(this.accountDate).format('YYYYMM') : '全部') + (this.endMonth ? '-' + moment(this.endMonth, 'YYYY-MM').format('YYYYMM') : ''), headers, rows);
			},
			doPrint() {
				window.print();
			}
		}
	};
</script>

<style scoped lang="less">
	.range-sep {
		margin: 0 8px;
		line-height: 30px;
		vertical-align: middle;
	}
	.abnormal-balance {
		color: #f56c6c;
		font-weight: bold;
	}
	.summary {
		width: 100%;
		border-collapse: collapse;

		td {
			padding: 0 8px;
			border: 1px solid #eee;
			font-size: 12px;
			height: 32px;
		}

		.summary:nth-child(even) {
			background-color: #f8fbf8;
		}

		.summary:hover {
			background-color: #dff7df;
		}


		.header {
			td {
				text-align: center;
				font-weight: bold;
				height: 35px;
			}
		}

		.type-header {
			td {
				background-color: #e8f0fe;
				font-weight: bold;
				text-align: left;
			}
		}
	}

	.cus-table .type-header td {
		background-color: #e8f0fe;
		font-weight: bold;
		text-align: left;
	}
</style>
